<template>
    <div class="p-4 border-b border-gray-200">
        <p class="text-[10px] font-bold uppercase tracking-[0.15em] text-primary-500 mb-3">
            Find Record
        </p>

        <div class="relative">
            <input
                v-model="query"
                type="text"
                placeholder="Search by name, email..."
                class="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all"
                @input="onSearch"
            />
            <i v-if="loading" class="fa-solid fa-spinner-third fa-spin absolute right-3 top-3 text-primary-500 text-sm"></i>
        </div>

        <div
            v-if="results.length > 0"
            class="mt-3 space-y-1.5 max-h-[320px] overflow-y-auto"
        >
            <button
                v-for="result in results"
                :key="result.type + ':' + result.id"
                class="w-full text-left rounded-lg p-3 transition-all duration-150"
                :class="isSelected(result)
                    ? 'bg-primary-500 text-white shadow-md shadow-primary-500/20'
                    : 'bg-gray-50 hover:bg-gray-100 border border-gray-200 hover:border-gray-300 text-gray-900'"
                @click="$emit('record-selected', result)"
            >
                <div class="flex items-center justify-between gap-2">
                    <span class="font-medium text-sm truncate">{{ result.name }}</span>
                    <span
                        class="flex-shrink-0 text-[10px] px-2 py-0.5 rounded-md font-semibold uppercase tracking-wide"
                        :class="isSelected(result) ? 'bg-white/20 text-white' : typeBadgeClass(result.type)"
                    >
                        {{ result.type }}
                    </span>
                </div>
                <div v-if="result.organization" class="text-xs mt-1 truncate" :class="isSelected(result) ? 'text-white/80' : 'text-gray-500'">
                    {{ result.organization }}
                </div>
                <div v-if="result.email" class="text-[11px] mt-0.5 truncate" :class="isSelected(result) ? 'text-white/60' : 'text-gray-400'">
                    {{ result.email }}
                </div>
            </button>
        </div>

        <div
            v-else-if="query.length >= 2 && !loading"
            class="mt-4 text-center text-xs text-gray-400 py-4"
        >
            No records found
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecordSearch',
    props: {
        selectedRecord: { type: Object, default: null },
    },
    emits: ['record-selected'],
    data() {
        return { query: '', results: [], loading: false, debounceTimer: null }
    },
    methods: {
        isSelected(result) {
            return this.selectedRecord && this.selectedRecord.id === result.id && this.selectedRecord.type === result.type
        },
        onSearch() {
            clearTimeout(this.debounceTimer)
            if (this.query.length < 2) { this.results = []; return }
            this.debounceTimer = setTimeout(() => this.fetchResults(), 300)
        },
        async fetchResults() {
            this.loading = true
            try {
                const response = await fetch(`/admin/email-composer/search?q=${encodeURIComponent(this.query)}`)
                const json = await response.json()
                this.results = json.results ?? []
            } catch (err) {
                console.error('RecordSearch fetch failed:', err)
                this.results = []
            } finally {
                this.loading = false
            }
        },
        typeBadgeClass(type) {
            return {
                Contact: 'bg-primary-100 text-primary-700 border border-primary-200',
                Lead: 'bg-amber-100 text-amber-700 border border-amber-200',
                Account: 'bg-sky-100 text-sky-700 border border-sky-200',
                Opportunity: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
            }[type] ?? 'bg-gray-100 text-gray-600'
        },
    },
}
</script>
